"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonStringifyError = exports.JsonParseError = exports.NetworkError = exports.HttpError = void 0;
/**
 * HttpError - thrown when the server's response has a `4xx` or `5xx` status
 * code.
 */
class HttpError extends Error {
    constructor(responseText, request, response) {
        const statusCode = response.status;
        const status = `${statusCode} ${response.statusText}`.trim();
        super(`Request failed with status code ${status}: ${request.method} ${request.url}`);
        this.name = "HttpError";
        this.response = response.clone();
        this.request = request;
        this.statusCode = statusCode;
        this.responseText = responseText;
    }
    get trimmedResponseText() {
        return this.responseText.replace(/\s\s+/g, " ").trim();
    }
}
exports.HttpError = HttpError;
/**
 * NetworkError - thrown when the client couldn't successfully communicate with
 * the server. Here's a non-exhastive list of the reasons this could happen:
 * - The client's network is offline or flakey
 * - The endpoint doesn't exist
 * - The server that should be responsible for the request is unresponsive
 * - The client aborted the request with an AbortController
 * - The request was malformed
 *
 * For more information see:
 * https://developer.mozilla.org/en-US/docs/Web/API/fetch#exceptions
 */
class NetworkError extends Error {
    constructor(request, error) {
        const message = error instanceof Error ? error.message : "Unknown NetworkError";
        super(message);
        this.name = "NetworkError";
        this.request = request;
        this.originalError = error;
    }
}
exports.NetworkError = NetworkError;
class JsonParseError extends Error {
    constructor(request, response, error) {
        const message = error instanceof Error ? error.message : "Unknown JsonParseError";
        super(message);
        this.name = "JsonParseError";
        this.request = request;
        this.response = response;
        this.originalError = error;
    }
}
exports.JsonParseError = JsonParseError;
class JsonStringifyError extends Error {
    constructor(request, data, error) {
        const message = error instanceof Error
            ? error.message
            : "Unknown JsonStringifyError";
        super(message);
        this.name = "JsonStringifyError";
        this.request = request;
        this.data = data;
        this.originalError = error;
    }
}
exports.JsonStringifyError = JsonStringifyError;
//# sourceMappingURL=errors.js.map